import ConsultaBase from "../shared/ConsultaBase";
import { ezchiller2compConsultaConfig } from "../config/ezchiller2compConsulta";

const CezChiller2Comp = () => {
  return <ConsultaBase config={ezchiller2compConsultaConfig} />;
};

export default CezChiller2Comp;